<template>
  <div class="h-100 d-flex justify-center align-center">
    <div class="text-center">
      <h1>404 Not Found.</h1>
      <router-link to="/">TOPへ戻る</router-link>
    </div>
  </div>
</template>
